import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {SmoothActionBar} from "../../../../../../misc/SmoothActionBar";
import {Dialog2} from "../../../../../../misc/Dialog2";
import {useState} from "react";

export function ConfigureDegreesOfOpening(props: {
    isPair: boolean;
    degreesActive: number | null;
    degreesInactive: number | null;
    onChange(v: {active: number | null, inactive: number | null})
    onClose(): void;
}) {
    const [active, setActive] = useState(props.degreesActive ? props.degreesActive.toString() : "");
    const [inactive, setInactive] = useState(props.degreesInactive ? props.degreesInactive.toString() : "");

    const submit = () => {
        props.onChange({
            active: intOrNull(active),
            inactive: intOrNull(inactive),
        })
    };

    return (
        <Dialog2 open onClose={() => props.onClose()} onEnterPress={submit}>
            <DialogTitle>
                Configure Degrees of Opening
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <div style={{
                    display: 'flex',
                    flexDirection: "column",
                    gap: 8,
                }}>
                    <TextField
                        label="Active"
                        value={active}
                        onChange={e => setActive(e.currentTarget.value.replace(/[^0-9.]+/g, ""))}
                    />

                    {props.isPair && <TextField
                        label="In-Active"
                        value={inactive}
                        onChange={e => setInactive(e.currentTarget.value.replace(/[^0-9.]+/g, ""))}
                    />}
                </div>
            </DialogContent>
            <SmoothActionBar
                onCancel={() => props.onClose()}
                onSubmit={submit}
                actionName="Update"
            />
        </Dialog2>
    )
}


export function intOrNull(input: string): number | null {
    input = input.trim();
    if(input === "") return null;
    try {
        const value = parseInt(input);
        if(isNaN(value)) throw new Error("invalid number");

        return value;
    } catch (e) {
        return null;
    }
}